import { apiClient } from "../../../../lib/axios";

export type NotificationTargetType = "all" | "client" | "user";

export interface SendNotificationPayload {
  title: string;
  body: string;
  data?: Record<string, string>;
  target: {
    type: NotificationTargetType;
    client_id?: string;
    user_id?: string;
  };
}

export interface SendNotificationResult {
  recipients: number;
  success: number;
  failure: number;
}

export const notificationsApi = {
  send: (payload: SendNotificationPayload) =>
    apiClient
      .post<{ data: SendNotificationResult }>("/admin/notifications/send", payload)
      .then((r) => r.data),
};
